/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Why automated submission is not available, set alongside `is_automated_submission_available: false` when the check ran.
 * @export
 */
export const PalReauthAutomatedSubmissionUnavailableReason = {
    PreAuthNotFound: 'pre_auth_not_found',
    SettingDisabled: 'setting_disabled',
    PreAuthNotAutomated: 'pre_auth_not_automated',
    PlatformNotSupported: 'platform_not_supported',
    ReauthPayorNotSupported: 'reauth_payor_not_supported',
    PlatformNotEnabled: 'platform_not_enabled',
    PayorNotSupported: 'payor_not_supported',
    PayorInBetaNotAllowlisted: 'payor_in_beta_not_allowlisted',
    CredentialsMissing: 'credentials_missing',
    PreAuthMissingExternalId: 'pre_auth_missing_external_id',
    MissingPermission: 'missing_permission',
} as const;
export type PalReauthAutomatedSubmissionUnavailableReason = typeof PalReauthAutomatedSubmissionUnavailableReason[keyof typeof PalReauthAutomatedSubmissionUnavailableReason];


export function instanceOfPalReauthAutomatedSubmissionUnavailableReason(value: any): boolean {
    for (const key in PalReauthAutomatedSubmissionUnavailableReason) {
        if (Object.prototype.hasOwnProperty.call(PalReauthAutomatedSubmissionUnavailableReason, key)) {
            if (PalReauthAutomatedSubmissionUnavailableReason[key as keyof typeof PalReauthAutomatedSubmissionUnavailableReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PalReauthAutomatedSubmissionUnavailableReasonFromJSON(json: any): PalReauthAutomatedSubmissionUnavailableReason {
    return PalReauthAutomatedSubmissionUnavailableReasonFromJSONTyped(json, false);
}

export function PalReauthAutomatedSubmissionUnavailableReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthAutomatedSubmissionUnavailableReason {
    return json as PalReauthAutomatedSubmissionUnavailableReason;
}

export function PalReauthAutomatedSubmissionUnavailableReasonToJSON(value?: PalReauthAutomatedSubmissionUnavailableReason | null): any {
    return value as any;
}

export function PalReauthAutomatedSubmissionUnavailableReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): PalReauthAutomatedSubmissionUnavailableReason {
    return value as PalReauthAutomatedSubmissionUnavailableReason;
}

